<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path
      fill="#78909c"
      d="M3,21.197c0,0,2.768-6.287,10-6.287c7.231,0,10,6.287,10,6.287V24H3V21.197z"
    />
    <path
      fill="#ffa726"
      d="M13,13c-2.763,0-5-2.238-5-5s2.237-5,5-5c2.761,0,5,2.238,5,5S15.761,13,13,13"
    />
    <path
      fill="#78909c"
      d="M25,42.197c0,0,2.768-6.287,10-6.287c7.231,0,10,6.287,10,6.287V45H25V42.197z"
    />
    <path
      fill="#ffa726"
      d="M35,34c-2.763,0-5-2.238-5-5s2.237-5,5-5c2.761,0,5,2.238,5,5S37.761,34,35,34"
    />
    <path
      fill="#2196f3"
      d="M24,7c-0.676,0-1.342,0.038-2,0.107v4.042C22.656,11.061,23.32,11,24,11 c7.244,0,13.304,5.162,14.698,12h4.042C41.294,13.947,33.453,7,24,7z"
    />
    <path
      fill="#2196f3"
      d="M9.148,28H5.114c0.9,8.54,7.481,15.398,15.886,16.74v-4.042C14.803,39.435,9.997,34.336,9.148,28z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "ConnectedPeopleIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
